import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { code } from "./code";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      name: string;
      description: string;
    }>;
  }>("/setup/subjects", { params });
};

const post = function (data: { name: string; description: string }) {
  return api.post("/setup/subjects", data);
};

export const subjects = {
  get,
  post,
  code,
};
